import { render, staticRenderFns } from "./DocumentEdit.vue?vue&type=template&id=33afa8d4&scoped=true"
import script from "./DocumentEdit.vue?vue&type=script&lang=js"
export * from "./DocumentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33afa8d4",
  null
  
)

export default component.exports